// CONSTANTS are all caps.
const NS = "ImageSliderItem";
const CLS = "imageSliderItem";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/imageSliderItem.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class ImageSliderItem {

	constructor($el) {
		// $el is the widget node return by the loadImageSliderItem function
		this.$el = $el;
	}

	init() {
		this.setImageSliderItem();
	}

	setImageSliderItem() {
        let wg = $(this.$el);
        let prevClientX = null;
        let isDraging = false;
        let divider = wg.find(WG + 'divider');
        let layer = wg.find(WG + 'secondLayer');
        let innerLayer = wg.find(WG + 'visibleLayer');
        let imageSlickSlider = wg.find(WG + 'slides');

        // divider.css('left', '0px');
		// Initialized the top layer to cover 50% of the slide by default
		divider.css('left', '50%');
		layer.css('left', '50%');
		innerLayer.css('left', '-50%');

        imageSlickSlider.slick({
            arrows: false,
            dots: true
        });

	    divider.mousedown((e) => {
	        isDraging = true;
	        prevClientX = e.clientX;
        });

	    $(document).mousemove((e) => {
	        if(!isDraging) return;
            let diff = e.clientX - prevClientX;
            prevClientX = e.clientX;
            let left = parseInt(divider.css('left'));
            left += diff;

            if(left >= wg.find(WG + 'desktop').width()) left = wg.find(WG + 'desktopContent').width();

            if(left < 0) left = 0;

            divider.css('left', left + 'px');
            layer.css('left', left + 'px');
            innerLayer.css('left', -left + 'px');
        });

	    $(document).mouseup((e) => {
            isDraging = false;
        });

	    // Work-around when slick slider layout is broken after showing.
	    // @ref https://stackoverflow.com/questions/31955382/slick-carousel-has-0px-width-when-loaded-in-collapsed-tab/32107099#32107099
        // @todo should research a better solution.
	    $(document).click((e) => {
	        imageSlickSlider.slick('setPosition');
        })
	}
}
